/**
 * Provider scratch notes from the session clinical sidebar (`zoom-sidebar-session-notes`), kept on the
 * Appointment (staff-only: client policies hide `extension`). They guide AI note generation and are not part of the signed note.
 */
import type { Appointment } from '@medplum/fhirtypes';

import { SESSION_SIDEBAR_NOTES_EXT } from '../constants';
import { getAppointmentExtensions, setAppointmentExtensions } from './appointment';

/** The trimmed sidebar notes, or `''`. */
export function getSessionSidebarNotes(appointment: Appointment): string {
  return getAppointmentExtensions(appointment, SESSION_SIDEBAR_NOTES_EXT)[0]?.valueString?.trim() ?? '';
}

/** A copy of the Appointment with the notes set (blank removes them). */
export function setSessionSidebarNotes(appointment: Appointment, notes: string): Appointment {
  const trimmed = notes.trim();
  const next = { ...appointment };
  setAppointmentExtensions(
    next,
    SESSION_SIDEBAR_NOTES_EXT,
    trimmed ? [{ url: SESSION_SIDEBAR_NOTES_EXT, valueString: trimmed }] : [],
  );
  return next;
}
